import React, { useEffect, useState } from 'react';
import { Lightbulb, Link2, X } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';

export const VerbundVorschlaege = ({ mnr, onVerknuepft }) => {
  const [items, setItems] = useState([]);
  const [info, setInfo] = useState(true);
  useEffect(() => { api.get(`/register/mandanten/${mnr}/vorschlaege`).then((r) => setItems(r.data.items || [])).catch(() => {}); }, [mnr]);
  if (!items.length) return null;
  const weg = (nr) => setItems((x) => x.filter((i) => i.mandanten_nr !== nr));
  const verknuepfen = async (v) => {
    try { await api.post(`/register/mandanten/${mnr}/verbund`, { mandanten_nr: v.mandanten_nr, informieren: info }); toast.success(`M-${v.mandanten_nr} verknüpft${info ? ' – Mandant per E-Mail informiert' : ''}`); weg(v.mandanten_nr); onVerknuepft?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Verknüpfen fehlgeschlagen'); }
  };
  const ignorieren = async (v) => { await api.post(`/register/mandanten/${mnr}/vorschlaege/ignorieren`, { mandanten_nr: v.mandanten_nr }).catch(() => {}); weg(v.mandanten_nr); window.dispatchEvent(new Event('verbund-geaendert')); };
  return (
    <div className="space-y-2" data-testid="verbund-vorschlaege">
      <label className="flex items-center gap-2 text-xs text-[#34536b] cursor-pointer px-1">
        <input type="checkbox" checked={info} onChange={(e) => setInfo(e.target.checked)} className="accent-[#1B3A5C]" data-testid="verbund-vorschlag-informieren" /> Beim Verknüpfen Mandant per E-Mail informieren
      </label>
      {items.map((v) => (
        <div key={v.mandanten_nr} className="flex flex-wrap items-center gap-3 rounded-2xl border border-[#b8893d]/40 bg-[#fbf7f0] px-4 py-3" data-testid={`verbund-vorschlag-${v.mandanten_nr}`}>
          <Lightbulb className="w-4 h-4 text-[#b8893d] shrink-0" />
          <p className="text-sm text-[#1B3A5C] flex-1 min-w-[220px]">
            <b className="font-mono">M-{v.mandanten_nr}</b> {v.name ? `(${v.name}) ` : ''}hat {v.gruende.includes('E-Mail') && v.gruende.includes('Name') ? 'dieselbe E-Mail und denselben Namen' : v.gruende.includes('E-Mail') ? 'dieselbe E-Mail' : 'denselben Vor- und Nachnamen'}. Verknüpfen?
          </p>
          <button type="button" onClick={() => verknuepfen(v)} className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-full bg-[#1B3A5C] text-white text-xs" data-testid={`verbund-vorschlag-verknuepfen-${v.mandanten_nr}`}><Link2 className="w-3.5 h-3.5" /> Verknüpfen</button>
          <button type="button" onClick={() => ignorieren(v)} className="inline-flex items-center gap-1 h-8 px-3 rounded-full border border-gray-300 text-xs text-[#34536b] hover:border-[#1B3A5C]" data-testid={`verbund-vorschlag-ignorieren-${v.mandanten_nr}`}><X className="w-3.5 h-3.5" /> Ignorieren</button>
        </div>
      ))}
    </div>
  );
};

export default VerbundVorschlaege;
